import { Service } from '@piwikpro/platform';

@Service()
export class GoneError extends Error {
  name = 'GoneError';

  errors = {};
}
